/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { getStatusBtnStyle } from "./ReviewsHelper";
import { useCallback, useMemo, useRef } from "react";

import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import { convertDate } from "@Services/luxonHelper";
import { resourceActivityInReviewUrl } from "@Services/dataManager";
import OpenFileInViewerIcon from "@Assets/icons/OpenInViewer.svg";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import { getViewerUrl } from "@Helpers";

import { renderUserTag } from "@CubeComponents/html/userTagDom";
import { portalCreateRoot } from "@CubeComponents/html/cellPortals";
const ResourceActivityInReview = ({ reviewId, spaceId, projectId }) => {
  const fileSizeOptions = [
    { name: "KB", divideValue: 1024 },
    { name: "MB", divideValue: 1048576 },
  ];

  const query = useMemo(
    () => ({
      params: {
        reviewId,
      },
    }),
    [reviewId],
  );
  const dataGrid = useRef(null);

  const openFileInViewer = (e) => {
    const fileVersionId = e.currentTarget.dataset.fileversionid;

    const viewerUrl = getViewerUrl({ fileVersionId, spaceId, projectId });
    window.open(viewerUrl, "_blank");
  };

  const getFileSizeOptionIndex = (size) => {
    const index = size > fileSizeOptions[1]!.divideValue ? 1 : 0;
    return index;
  };

  const openFileInViewerFormatter = (row, cell, value, columnDef, dataContext) => {
    const container = document.createElement("div");
    container.className = "cursor-pointer";
    container.dataset.fileversionid = dataContext.fileVersionId;
    container.onclick = openFileInViewer;
    const img = document.createElement("img");
    img.src = OpenFileInViewerIcon;
    container.appendChild(img);
    return container;
  };

  const fileNameFormatter = (row, cell, value, columnDef, dataContext) => {
    const { fileDetails } = dataContext;
    const container = document.createElement("div");
    portalCreateRoot(container).render(
      <ToolTipComponent showTipPointer position="bottom" content={fileDetails.name}>
        <p>{fileDetails.name}</p>
      </ToolTipComponent>,
    );
    return container;
  };

  const fileSizeFormatter = (row, cell, value, columnDef, dataContext) => {
    const { size } = dataContext.fileDetails;
    const fileSizeIndex = getFileSizeOptionIndex(size);
    const fileSizeOption = fileSizeOptions[fileSizeIndex];
    const formattedValue = parseFloat(String(size / fileSizeOption!.divideValue)).toFixed(2);
    return `${formattedValue} ${fileSizeOption!.name}`;
  };

  const versionFormatter = (row, cell, value, columnDef, dataContext) => {
    const { fileDetails } = dataContext;
    return `V${fileDetails.versionNumber}`;
  };

  const creatorFormatter = (row, cell, value, columnDef, dataContext) => {
    const container = document.createElement("div");
    renderUserTag(container, { id: dataContext.userDetails.userId });
    return container;
  };

  const dateFormatter = (row, cell, value, columnDef, dataContext) => {
    const dateFormat = convertDate(Number(dataContext.createdDate), "dateForTooltip");
    const container = document.createElement("div");
    container.className = "inline-flex";
    portalCreateRoot(container).render(
      <ToolTipComponent showTipPointer position="bottom" content={dateFormat}>
        <span>{convertDate(Number(dataContext.createdDate), "dateForText")}</span>
      </ToolTipComponent>,
    );
    return container;
  };

  const statusFormatter = (row, cell, value, columnDef, dataContext) => {
    if (!dataContext.status?._id) {
      return "-";
    }
    const style = getStatusBtnStyle(dataContext.status.category);
    const container = document.createElement("span");
    container.className = "rounded py-1 px-4 text-sm text-white";
    Object.assign(container.style, style);
    container.textContent = dataContext.status.name;
    return container;
  };

  const modificationTypeFormatter = (row, cell, value, columnDef, dataContext) => {
    const { type, fileDetailsUpdatedTo } = dataContext;

    if (type === "review_resource_added") {
      return "Added";
    }
    if (type === "review_resource_removed") {
      return "Removed";
    }
    if (type === "review_resource_updated") {
      return `Updated To V${fileDetailsUpdatedTo.versionNumber}`;
    }
    return "";
  };

  const columnDefinitions = useMemo(
    () => [
      {
        id: "openInViewer",
        field: "fileVersionId",
        name: "",
        minWidth: 50,
        maxWidth: 50,
        formatter: openFileInViewerFormatter,
        disableFiltering: true,
        disableSorting: true,
        disableGrouping: true,
      },
      {
        id: "fileName",
        field: "fileDetails.name",
        name: "File Name",
        minWidth: 200,
        formatter: fileNameFormatter,
        clipMode: "EllipsisWithTooltip",
      },
      {
        id: "size",
        field: "fileDetails.size",
        name: "Size",
        minWidth: 100,
        formatter: fileSizeFormatter,
      },
      {
        id: "version",
        field: "fileDetails.versionNumber",
        name: "Version",
        minWidth: 80,
        formatter: versionFormatter,
      },
      {
        id: "creator",
        field: "userDetails.userId",
        name: "Creator",
        minWidth: 150,
        formatter: creatorFormatter,
        _valueGetter: (row: any) => row?.userDetails?.userId,
        _excelValueGetter: (row: any) =>
          row?.userDetails?.fullName || row?.userDetails?.name || row?.userDetails?.userId || "",
        disableFiltering: true,
        disableSorting: true,
        disableGrouping: true,
      },
      {
        id: "createdDate",
        field: "createdDate",
        name: "Date",
        minWidth: 150,
        formatter: dateFormatter,
        filterType: "Date",
      },
      {
        id: "status",
        field: "status.name",
        name: "Status",
        minWidth: 120,
        formatter: statusFormatter,
        _valueGetter: (row: any) => row?.status?.name,
      },
      {
        id: "modificationType",
        field: "type",
        name: "Modification Type",
        minWidth: 150,
        formatter: modificationTypeFormatter,
      },
    ],

    [],
  );

  const getDataGrid = useCallback(
    () => (
      <SlickGrid1
        ref={dataGrid}
        remoteDataSource={resourceActivityInReviewUrl}
        query={query}
        columnDefinitions={columnDefinitions as any}
        rowHeight={60}
        gridHeight="100%"
        enableFilteringOption
        enableSortingOption
        infiniteScroll
      />
    ),
    [query, columnDefinitions],
  );

  return getDataGrid();
};

export default ResourceActivityInReview;
